<template>
  <div class="main">
    <div class="home" v-if="!isPad">
      <a-breadcrumb style="margin: 20px 0px 0 50px">
        <a-breadcrumb-item class="breadcrumb">
          <router-link :to="'/homePage/'">首页</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item class="breadcrumb">
          学生画像
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="content flex-row justify-between common-display-flex">
        <div class="class-trees">
        <span class="class-toggle" :class="isDivVisible?'class-toggle_left':'class-toggle_right'"
              @click="toggleDiv"> {{ isDivVisible ? '展开' : '收起' }}</span>
          <transition name="fade">
            <div class="class-tree myDiv" v-if="!isDivVisible">
              <a-tree
                  :show-line="showLine"
                  :show-icon="showIcon"
                  :tree-data="treeData"
                  v-if="treeData.length>0"
                  :default-expanded-keys="defaultExpandedKeys"
                  :default-selected-keys="['2']"
                  :replace-fields="replaceFields"
                  @select="onSelect"
              >

              </a-tree>
            </div>
          </transition>
        </div>

        <div class="class-detail common-flex-grow">
          <div class="justify-between mt-20">
            <a-breadcrumb>
              <a-breadcrumb-item class="fz-14" v-if="bookname">
                {{ bookname }}
              </a-breadcrumb-item>
              <a-breadcrumb-item class="fz-14" v-if="unitname">
                {{ unitname }}
              </a-breadcrumb-item>
              <a-breadcrumb-item class="fz-14" v-if="lessonname">
                {{ lessonname }}
              </a-breadcrumb-item>
            </a-breadcrumb>
            <span class="classSpan" @click="() => {this.$router.push({ name: 'HomeCourseComparison' })}">课程对比</span>
          </div>

          <div class="class-option">
            <div class="flex-row">
              <span style="width: 60px;font-size: 14px">表现：</span>
              <div v-for="(item, index) in classType" @click="onTypeChange(index)" :key="index">
                <span :class="currentType==index?'classSpan':'classAct'">{{ item.name }}</span>
              </div>
              <a-button class="classExport" :loading="downBtnLoading" @click="downloadExcel">导出</a-button>
            </div>
            <div class="flex-row">
              <span class="class-option-title mt-20">班级：</span>
              <div class="class-option-content mt-20" v-if="currentType!=2">
                <a-checkbox-group :defaultValue="classCheckedList" @change="classChange" v-model="classCheckedList">
                  <a-checkbox :value="item" v-for="item in classList" :key="item.id">
                    <a-tooltip placement="topLeft" :title="item.className">
                      {{ item.className }}
                    </a-tooltip>
                  </a-checkbox>
                </a-checkbox-group>
                <span class="class-option-empty" v-show="classList.length==0">暂无班级</span>
              </div>
              <div class="class-option-content mt-20" v-if="currentType==2">
                <a-radio-group :defaultValue="classCheckedList" @change="relationshipChange" v-model="classCheckedList">
                  <a-radio :value="item" v-for="item in classList" :key="item.id">
                    <a-tooltip placement="topLeft" :title="item.className">
                      {{ item.className }}
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
                <span class="class-option-empty" v-show="classList.length==0">暂无班级</span>
              </div>
            </div>
            <div class="flex-col">
              <div class="flex-row" v-show="currentType==1">
                <span class="class-option-title mt-10">学生：</span>
                <div class="class-option-content mt-10" v-if="classShow">
                  <a-checkbox-group :defaultValue="studentsCheckedList" @change="studentChange"
                                    v-model="studentsCheckedList">
                    <a-checkbox :value="item" v-for="item in studentListCheck" :key="item.userId||''"
                                :disabled="item.disabled">
                        {{ item.userName }}
                    </a-checkbox>
                  </a-checkbox-group>
                  <span class="class-option-empty" v-show="studentListCheck.length==0">暂无学生</span>
                </div>
                <div>
                  <span class="class-option-more" v-show="false" @click="studentShowMore">显示更多</span>
                </div>
              </div>
            </div>
          </div>
          <div class="class-behaves common-display-flex" v-show="currentType!=2">
            <div class="flex-col common-flex">
              <a-spin :spinning="main" :tip="tipsText">
                <div class="class-behave">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}被动行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue"> 阅读行为</span>
                      <span class="behave_content"> {{ readTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 听诵读</span>
                      <span class="behave_content">{{ radioTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 视频学习</span>
                      <span class="behave_content"> {{ videoTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="main" v-if="!mainEmpty">
                  </div>
                  <a-empty v-if="mainEmpty"/>
                </div>
              </a-spin>
              <a-spin :spinning="create" :tip="tipsText">
                <div class="class-behave">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}构建行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue">任务活动数量</span>
                      <span class="behave_content">  {{ activityTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 任务活动获得星星数量</span>
                      <span class="behave_content"> {{ starTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 主观题数量</span>
                      <span class="behave_content">  {{ subjectiveTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="create" v-if="!createEmpty"></div>
                  <a-empty v-if="createEmpty"/>
                </div>

              </a-spin>
            </div>
            <div class="flex-col common-flex">
              <a-spin :spinning="positive" :tip="tipsText">
                <div class="class-behave ml-20">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}主动行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue"> 标注</span>
                      <span class="behave_content">  {{ dimensionTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 朗读</span>
                      <span class="behave_content"> {{ readingTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 完成客观题数量</span>
                      <span class="behave_content">  {{ objectiveTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title purple"> 正确客观题数量</span>
                      <span class="behave_content">  {{ objectiveCorrectTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="positive" v-if="!positiveEmpty"></div>
                  <a-empty v-if="positiveEmpty"/>
                </div>
              </a-spin>
              <a-spin :spinning="interaction" :tip="tipsText">
                <div class="class-behave ml-20">
                  <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}交互行为</span>
                  <div class="flex-row justify-between ml-20 mr-20">
                    <div class="flex-col">
                      <span class="behave_title blue"> 评论</span>
                      <span class="behave_content">  {{ commentTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title green"> 提问</span>
                      <span class="behave_content"> {{ askTotal }}</span>
                    </div>
                    <div class="flex-col">
                      <span class="behave_title yellow"> 点赞</span>
                      <span class="behave_content">  {{ praiseTotal }}</span>
                    </div>
                  </div>
                  <div class="class-echarts" id="interaction" v-if="!interactionEmpty"></div>
                  <a-empty v-if="interactionEmpty"/>
                </div>
              </a-spin>
            </div>
          </div>
          <div class="class-types" v-show="currentType!=2">
            <a-spin :spinning="learntype" :tip="tipsText">
              <div class="class-behave-type">
                <span class="class-type">  {{ currentType == 0 ? '班级' : '学生' }}学习类型</span>
                <div class="class-echarts-2" id="learntype" v-if="!learntypeEmpty"></div>
                <a-empty class="ant-empty2" v-if="learntypeEmpty"/>
              </div>
            </a-spin>
          </div>
          <div class="class-jiaohu flex-col" v-show="currentType==2">
            <div class="justify-between">
              <span>交互关系</span>
            </div>
            <a-spin :spinning="jiaohu" :tip="tipsText">
              <div class="class-echarts-3" id="jiaohu" v-if="!jiaohuEmpty"></div>
              <a-empty class="ant-empty3" v-if="jiaohuEmpty"/>
            </a-spin>
          </div>
        </div>
      </div>
    </div>

    <div class="phone" v-if="isPad">
      <div class="left-tree flex-row  common-display-flex">

        <div class="class-trees">
          <div class="class-toggle class-toggle_right" v-if="!isDivVisible" @click="toggleDiv">
            收起
          </div>
          <transition name="fade">
            <div class="class-tree" v-if="!isDivVisible">
              <a-tree
                  :show-line="showLine"
                  :show-icon="showIcon"
                  :tree-data="treeData"
                  v-if="treeData.length>0"
                  :default-expanded-keys="defaultExpandedKeys"
                  :default-selected-keys="['2']"
                  :replace-fields="replaceFields"
                  @select="onSelect"
              >

              </a-tree>
            </div>
          </transition>
          <div style="width: 10px" v-if="isDivVisible"></div>

        </div>

        <div class="class-detail common-flex-grow">
          <div class="justify-between mt-20">
            <div class="class-toggle class-toggle_left" v-if="isDivVisible" @click="toggleDiv">
              展开
            </div>
            <div class="mr-20 mt-10">
              <a-breadcrumb>
                <a-breadcrumb-item class="fz-14" v-if="bookname">
                  {{ bookname }}
                </a-breadcrumb-item>
                <a-breadcrumb-item class="fz-14" v-if="unitname">
                  {{ unitname }}
                </a-breadcrumb-item>
                <a-breadcrumb-item class="fz-14" v-if="lessonname">
                  {{ lessonname }}
                </a-breadcrumb-item>
              </a-breadcrumb>
            </div>
            <span class="classSpan nowrap" style="height: 35px"
                  @click="() => {this.$router.push({ name: 'PhoneCourseComparision' })}">课程对比</span>
          </div>

          <div class="class-option ">
            <div class="flex-row">
              <span class="class-option-title">表现：</span>
              <div class="flex-row justify-between">
                <div v-for="(item, index) in classType" @click="onTypeChange(index)" :key="index" class="mb-10">
                  <span :class="currentType==index?'classSpan':'classAct'">{{ item.name }}</span>
                </div>
              </div>
            </div>
            <div class="flex-row">
              <span class="class-option-title mt-20">班级：</span>
              <div class="class-option-content mt-20" v-if="currentType!=2">
                <a-checkbox-group :defaultValue="classCheckedList" @change="classChange"
                                  v-model="classCheckedList"
                                  style="display: initial;white-space:initial">
                  <a-checkbox :value="item" v-for="item in classList" :key="item.id">
                    <a-tooltip placement="topLeft" :title="item.className">
                      {{ item.className }}
                    </a-tooltip>
                  </a-checkbox>
                </a-checkbox-group>
                <span class="class-option-empty" v-show="classList.length==0">暂无班级</span>
              </div>
              <div class="class-option-content mt-20" v-if="currentType==2">
                <a-radio-group :defaultValue="classCheckedList" @change="relationshipChange" v-model="classCheckedList">
                  <a-radio :value="item" v-for="item in classList" :key="item.id">
                    <a-tooltip placement="topLeft" :title="item.className">
                      {{ item.className }}
                    </a-tooltip>
                  </a-radio>
                </a-radio-group>
                <span class="class-option-empty" v-show="classList.length==0">暂无班级</span>
              </div>
            </div>
            <div class="flex-col">
              <div class="flex-row" v-show="currentType==1">
                <span class="class-option-title mt-10">学生：</span>
                <div class="class-option-content mt-10" v-if="classShow">
                  <a-checkbox-group :defaultValue="studentsCheckedList" @change="studentChange"
                                    v-model="studentsCheckedList">
                    <a-checkbox :value="item" v-for="item in studentListCheck" :key="item.userId||''">
                      <a-tooltip placement="topLeft" :title="item.userName">
                        {{ item.userName }}
                      </a-tooltip>
                    </a-checkbox>
                  </a-checkbox-group>
                  <span class="class-option-empty" v-show="studentListCheck.length==0">暂无学生</span>
                </div>
                <span class="class-option-more" v-show="false"
                      onclick="studentShowMore()">显示更多</span>
              </div>
            </div>
          </div>
          <div class="class-behaves " v-show="currentType!=2">

            <a-spin :spinning="main" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}被动行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue"> 阅读行为</span>
                    <span class="behave_content"> {{ readTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 听诵读</span>
                    <span class="behave_content">{{ radioTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 视频学习</span>
                    <span class="behave_content"> {{ videoTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="main" v-if="!mainEmpty">
                </div>
                <a-empty v-if="mainEmpty"/>
              </div>
            </a-spin>
            <a-spin :spinning="create" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}构建行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue">任务活动数量</span>
                    <span class="behave_content">  {{ activityTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 任务活动获得星星数量</span>
                    <span class="behave_content"> {{ starTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 主观题数量</span>
                    <span class="behave_content">  {{ subjectiveTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="create" v-if="!createEmpty"></div>
                <a-empty v-if="createEmpty"/>
              </div>
            </a-spin>
            <a-spin :spinning="positive" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type">{{ currentType == 0 ? '班级' : '学生' }}主动行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue"> 标注</span>
                    <span class="behave_content">  {{ dimensionTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 朗读</span>
                    <span class="behave_content"> {{ readingTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 完成客观题数量</span>
                    <span class="behave_content">  {{ objectiveTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title purple"> 正确客观题数量</span>
                    <span class="behave_content">  {{ objectiveCorrectTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="positive" v-if="!positiveEmpty"></div>
                <a-empty v-if="positiveEmpty"/>
              </div>
            </a-spin>
            <a-spin :spinning="interaction" :tip="tipsText">
              <div class="class-behave">
                <span class="class-type"> {{ currentType == 0 ? '班级' : '学生' }}交互行为</span>
                <div class="flex-row justify-between ml-20 mr-20">
                  <div class="flex-col">
                    <span class="behave_title blue"> 评论</span>
                    <span class="behave_content">  {{ commentTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title green"> 提问</span>
                    <span class="behave_content"> {{ askTotal }}</span>
                  </div>
                  <div class="flex-col">
                    <span class="behave_title yellow"> 点赞</span>
                    <span class="behave_content">  {{ praiseTotal }}</span>
                  </div>
                </div>
                <div class="class-echarts" id="interaction" v-if="!interactionEmpty"></div>
                <a-empty v-if="interactionEmpty"/>
              </div>
            </a-spin>

            <div class="">
              <a-spin :spinning="learntype" :tip="tipsText">
                <div class="class-behave">
                  <span class="class-type">  {{ currentType == 0 ? '班级' : '学生' }}学习类型</span>
                  <!--                  <div class="flex-row justify-between ml-20 mr-20">-->
                  <!--                    <div class="flex-col">-->
                  <!--                      <span class="behave_title blue "> 阅读行为</span>-->
                  <!--                      <span class="behave_content"> 00:30:00</span>-->
                  <!--                    </div>-->
                  <!--                    <div class="flex-col">-->
                  <!--                      <span class="behave_title green"> 听诵读</span>-->
                  <!--                      <span class="behave_content">00:30:00</span>-->
                  <!--                    </div>-->
                  <!--                    <div class="flex-col">-->
                  <!--                      <span class="behave_title yellow"> 视频学习</span>-->
                  <!--                      <span class="behave_content"> 00:30:00</span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="class-echarts-2" id="learntype" v-if="!learntypeEmpty"></div>
                  <a-empty class="ant-empty2" v-if="learntypeEmpty"/>
                </div>
              </a-spin>
            </div>
          </div>
          <div class="class-jiaohu flex-col" v-show="currentType==2">
            <div class="justify-between">
              <span>交互关系</span>
              <a-button class="classSpan" :loading="downBtnLoading" v-if="false" @click="enterDown">导出</a-button>
            </div>
            <a-spin :spinning="jiaohu" :tip="tipsText">
              <div class="class-echarts-3" id="jiaohu" v-if="!jiaohuEmpty"></div>
              <a-empty class="ant-empty3" v-if="jiaohuEmpty"/>
            </a-spin>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
ul,
li {
  margin: 0px;
  padding: 0px;
  list-style: none;
}

// 手机适配页面
.phone {
  width: 100%;
  overflow-y: hidden;

  .left-tree {
    height: 100%;
  }

  .class-trees {
    position: relative;
   // height: 100%;
    // min-height: 2080px;

    .class-toggle {
      position: absolute;
      //top: 4%;
      right: -1px;
      //left: 4%;
      width: 30px;
      color: #FFFFFF;
      font-size: 14px;
      min-height: 20px;
      text-align: center; /* 将文字水平居中对齐 */
      transform: translate(-50%, -50%);
      margin-top: 60px;
      z-index: 999;
    }

    .class-toggle_right {
      background-color: @primary-color; /* 背景颜色 */
      border-radius: 50% 0 0 50%; /* 设置半圆形状的圆角 */
      padding: 5px 0px 5px 5px; /* 文字的内边距 */
    }

    .class-tree {
      background: #FFFFFF;
      width: 180px;
      height: 100%;
      margin: 20px 15px 0 10px;
      border-radius: 10px;
      padding: 10px;
      overflow-x: hidden;
    }

    .hidden {
      display: none;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s ease-in-out;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }

  .class-detail {
    overflow-y: scroll;
    margin-right: 10px;
    flex-grow: 1;

    .class-toggle_left {
      background-color: @primary-color; /* 背景颜色 */
      border-radius: 0 50% 50% 0; /* 设置半圆形状的圆角 */
      padding: 5px 5px 5px 0px; /* 文字的内边距 */
      color: white;
    }

    .classAct {
      padding: 6px;
      color: #867D7B;
      background: #F1F0F0;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
      //white-space: nowrap;
      //overflow: hidden; /* 可选：隐藏超出容器的文本 */
      //text-overflow: ellipsis;
    }

    .classSpan {
      padding: 6px;
      color: #fff;
      background: @primary-color;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
      //white-space: nowrap;
      //overflow: hidden; /* 可选：隐藏超出容器的文本 */
      //text-overflow: ellipsis;
    }

    .class-option {
      background: #fff;
      margin-top: 20px;
      padding: 20px 10px 10px 10px;
      border-radius: 10px;

      .class-option-content {
        font-size: 16px;
        color: #000;

        .class-option-empty {
          font-size: 14px;
          text-align: center;
        }
      }

      .class-option-title {
        width: 50px;
        font-size: 14px;
      }

      .class-option-more {
        font-size: 14px;
        text-align: center;
        margin-top: 40px;
      }
    }

    .class-behaves {

      .class-behave {
        //overflow-y: hidden;
        //width: 100%;
        background: #fff;
        margin-top: 20px;
        padding: 30px 10px 10px 10px;
        border-radius: 10px;

        .class-type {
          font-size: 14px;
          font-weight: bold
        }

        .behave_title {
          margin-top: 10px;
          font-size: 13px;
          position: relative;
          display: inline-block;
          margin-right: 10px; /* 调整颜色块与文字之间的间距 */
          z-index: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .behave_title::before {
          content: '';
          position: absolute;
          left: -10px; /* 调整颜色块的位置 */
          top: 50%;
          transform: translateY(-50%);
          width: 5px; /* 设置颜色块的宽度 */
          height: 12px; /* 设置颜色块的高度 */
          z-index: -1;
        }

        .yellow::before {
          background-color: #32C1FF; /* 设置黄色颜色块的背景颜色 */
        }

        .purple::before {
          background-color: #FFD300; /* 设置紫色颜色块的背景颜色 */
        }

        .blue::before {
          //    color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
          background-color: #FF5F4C; /* 设置蓝色颜色块的背景颜色 */
        }

        .green::before {
          background-color: #FFAB45; /* 设置绿色颜色块的背景颜色 */
        }

        .behave_content {
          margin-top: 5px;
          font-size: 13px;
          text-align: center; /* 水平居中 */
        }

        .class-echarts {
          margin-top: 20px;
          max-width: 1200px;
          min-height: 200px;
          width: 100%;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 10px;
          padding: 5px;
        }

        .class-echarts-2 {
          margin-top: 20px;
          max-width: 1200px;
          min-height: 405px;
          width: 100%;
          //background: #e6f8f3;
          border-radius: 10px;
          padding: 5px;
        }
      }
    }

    .class-jiaohu {
      background: #fff;
      margin-top: 20px;
      padding: 30px 10px 10px 10px;
      border-radius: 10px;

      .class-echarts-3 {
        margin-top: 20px;
        max-width: 1200px;
        min-height: 560px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 10px;
      }
    }
  }

  /deep/ .ant-breadcrumb-separator {
    margin: 0 3px;
    color: rgba(0, 0, 0, 0.45);
  }
}

// 网页适配页面
.home {
  height: calc(100vh);
  //width: 100%;
  margin: 0 auto;
  min-width: 1024px;
  max-width: 1680px;
  overflow-x: hidden;
 // position: fixed;

  .content {
    // height: 100vh;
  }

  // 通用
  .spin {
    text-align: center;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 30px 50px;
    margin: 20px 0;
  }

  /deep/ .ant-checkbox-wrapper {
    // width: 220px;
    min-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 10px;
  }

  /deep/ .ant-radio-wrapper {
    font-size: 14px;
  }

  /deep/ .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }

  /deep/ .ant-checkbox-wrapper {
    font-size: 14px;
    color: #000;
  }

  ::-webkit-scrollbar-track-piece {
    //滚动条凹槽的颜色，还可以设置边框属性
    background-color: #f8f8f8;
  }

  ::-webkit-scrollbar {
    //滚动条的宽度
    width: 9px;
    height: 9px;
  }

  ::-webkit-scrollbar-thumb {
    //滚动条的设置
    background-color: #dddddd;
    background-clip: padding-box;
    min-height: 28px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #bbb;
  }

  .breadcrumb {
    font-size: 16px;
  }

  .class-trees {
    position: relative;
    margin-left: 10px;
    min-width: 50px;
    min-height: 82vh;
    //flex: 10;

    .class-toggle {
      position: absolute;
      top: 50%;
      right: 0;
      color: #FFFFFF;
      min-height: 40px;
      text-align: center; /* 将文字水平居中对齐 */
      transform: translate(-50%, -50%);
      z-index: 999;
    }

    .class-toggle_left {
      background-color: @primary-color; /* 背景颜色 */
      border-radius: 0 50% 50% 0; /* 设置半圆形状的圆角 */
      padding: 10px 10px 10px 0px; /* 文字的内边距 */
    }

    .class-toggle_right {
      background-color: @primary-color; /* 背景颜色 */
      border-radius: 50% 0 0 50%; /* 设置半圆形状的圆角 */
      padding: 10px 0px 10px 10px; /* 文字的内边距 */
    }

    .class-tree {
      background: #FFFFFF;
      min-height: 82vh;
      margin: 20px 20px 0 20px;
      border-radius: 10px;
      padding: 10px;
      overflow-x: hidden;
      overflow-y: auto;
    }

    .hidden {
      display: none;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s ease-in-out;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }

  .class-detail {
    margin-right: 20px;
    height: 84vh;
    overflow-x: scroll;

    //flex: 50;

    .classAct {
      padding: 6px 15px;
      color: #867D7B;
      background: #F1F0F0;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
    }

    .classSpan {
      padding: 6px 10px;
      color: #fff;
      background: @primary-color;
      font-size: 14px;
      cursor: pointer;
      margin-right: 10px;
      border-radius: 4px;
    }

    .class-option {
      background: #fff;
      margin-top: 20px;
      padding: 20px 10px 10px 10px;
      border-radius: 10px;

      .class-option-content {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #000;

        .class-option-empty {
          font-size: 14px;
          text-align: center;
        }
      }

      .class-option-title {
        width: 60px;
        font-size: 14px;

      }

      .class-option-more {
        width: 75px;
        font-size: 14px;
        text-align: center;
        margin-top: 40px;
      }

      .classExport {
        //  position: absolute;
        //  right: 40px;
        margin-left: auto;
        padding: 6px 10px;
        color: #fff;
        background: @primary-color;
        font-size: 14px;
        cursor: pointer;
        margin-right: 10px;
        border-radius: 4px;
      }
    }

    .class-behaves {

      .class-behave {
        background: #fff;
        margin-top: 20px;
        padding: 30px 10px 10px 10px;
        border-radius: 10px;
        // max-width: 40vw;

        .class-type {
          font-size: 14px;
          font-weight: bold
        }

        .behave_title {
          margin-top: 10px;
          font-size: 13px;
          position: relative;
          display: inline-block;
          margin-right: 10px; /* 调整颜色块与文字之间的间距 */
          z-index: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .behave_title::before {
          content: '';
          position: absolute;
          left: -10px; /* 调整颜色块的位置 */
          top: 50%;
          transform: translateY(-50%);
          width: 5px; /* 设置颜色块的宽度 */
          height: 12px; /* 设置颜色块的高度 */
          z-index: -1;
        }

        .yellow::before {
          background-color: #32C1FF; /* 设置黄色颜色块的背景颜色 */
        }

        .purple::before {
          background-color: #FFD300; /* 设置紫色颜色块的背景颜色 */
        }

        .blue::before {
          //    color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
          background-color: #FF5F4C; /* 设置蓝色颜色块的背景颜色 */
        }

        .green::before {
          background-color: #FFAB45; /* 设置绿色颜色块的背景颜色 */
        }

        .behave_content {
          margin-top: 5px;
          font-size: 13px;
          text-align: center; /* 水平居中 */
        }

        .class-echarts {
          margin-top: 20px;
          // max-width: 1200px;
          min-height: 30vh;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 10px;
          padding: 5px;
        }

        //.class-echarts-2 {
        //  margin-top: 20px;
        //  //max-width: 1200px;
        //  min-height: 80vh;
        //  //background: #e6f8f3;
        //  border-radius: 10px;
        //  padding: 5px;
        //}
      }

      .class-behave-type {
        align-content: center;
        background: #fff;
        margin-top: 20px;
        padding: 30px 10px 10px 10px;
        border-radius: 10px;
        max-width: 40vw;

        .class-type {
          font-size: 14px;
          font-weight: bold
        }

        .behave_title {
          margin-top: 10px;
          font-size: 13px;
          position: relative;
          display: inline-block;
          margin-right: 10px; /* 调整颜色块与文字之间的间距 */
          z-index: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .behave_title::before {
          content: '';
          position: absolute;
          left: -10px; /* 调整颜色块的位置 */
          top: 50%;
          transform: translateY(-50%);
          width: 5px; /* 设置颜色块的宽度 */
          height: 12px; /* 设置颜色块的高度 */
          z-index: -1;
        }

        .yellow::before {
          background-color: #32C1FF; /* 设置黄色颜色块的背景颜色 */
        }

        .purple::before {
          background-color: #FFD300; /* 设置紫色颜色块的背景颜色 */
        }

        .blue::before {
          //    color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
          background-color: #FF5F4C; /* 设置蓝色颜色块的背景颜色 */
        }

        .green::before {
          background-color: #FFAB45; /* 设置绿色颜色块的背景颜色 */
        }

        .behave_content {
          margin-top: 5px;
          font-size: 13px;
          text-align: center; /* 水平居中 */
        }

        .class-echarts {
          margin-top: 20px;
          // max-width: 1200px;
          min-height: 30vh;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 10px;
          padding: 5px;
        }

        //.class-echarts-2 {
        //  margin-top: 20px;
        //  //max-width: 1200px;
        //  min-height: 80vh;
        //  //background: #e6f8f3;
        //  border-radius: 10px;
        //  padding: 5px;
        //}
      }
    }

    .class-types {

      .class-behave {
        background: #fff;
        margin-top: 20px;
        padding: 30px 10px 10px 10px;
        border-radius: 10px;
        //max-width: 40vw;

        .class-type {
          font-size: 14px;
          font-weight: bold
        }

        .behave_title {
          margin-top: 10px;
          font-size: 13px;
          position: relative;
          display: inline-block;
          margin-right: 10px; /* 调整颜色块与文字之间的间距 */
          z-index: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .behave_title::before {
          content: '';
          position: absolute;
          left: -10px; /* 调整颜色块的位置 */
          top: 50%;
          transform: translateY(-50%);
          width: 5px; /* 设置颜色块的宽度 */
          height: 12px; /* 设置颜色块的高度 */
          z-index: -1;
        }

        .yellow::before {
          background-color: #32C1FF; /* 设置黄色颜色块的背景颜色 */
        }

        .purple::before {
          background-color: #FFD300; /* 设置紫色颜色块的背景颜色 */
        }

        .blue::before {
          //    color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
          background-color: #FF5F4C; /* 设置蓝色颜色块的背景颜色 */
        }

        .green::before {
          background-color: #FFAB45; /* 设置绿色颜色块的背景颜色 */
        }

        .behave_content {
          margin-top: 5px;
          font-size: 13px;
          text-align: center; /* 水平居中 */
        }

        .class-echarts {
          margin-top: 20px;
          // max-width: 1200px;
          min-height: 30vh;
          background: rgba(0, 0, 0, 0.05);
          border-radius: 10px;
          padding: 5px;
        }

      }

      .class-behave-type {
        align-content: center;
        background: #fff;
        margin-top: 20px;
        padding: 30px 10px 10px 10px;
        border-radius: 10px;
        //max-width: 40vw;

        .class-type {
          font-size: 14px;
          font-weight: bold
        }

        .behave_title {
          margin-top: 10px;
          font-size: 13px;
          position: relative;
          display: inline-block;
          margin-right: 10px; /* 调整颜色块与文字之间的间距 */
          z-index: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .behave_title::before {
          content: '';
          position: absolute;
          left: -10px; /* 调整颜色块的位置 */
          top: 50%;
          transform: translateY(-50%);
          width: 5px; /* 设置颜色块的宽度 */
          height: 12px; /* 设置颜色块的高度 */
          z-index: -1;
        }

        .yellow::before {
          background-color: #32C1FF; /* 设置黄色颜色块的背景颜色 */
        }

        .purple::before {
          background-color: #FFD300; /* 设置紫色颜色块的背景颜色 */
        }

        .blue::before {
          //    color: ['#FF5F4C', '#FFAB45', '#32C1FF', '#FFD300', '#17CE74', '#8E83E7', '#578EEF'],
          background-color: #FF5F4C; /* 设置蓝色颜色块的背景颜色 */
        }

        .green::before {
          background-color: #FFAB45; /* 设置绿色颜色块的背景颜色 */
        }

        .behave_content {
          margin-top: 5px;
          font-size: 13px;
          text-align: center; /* 水平居中 */
        }

        .class-echarts-2 {
          margin-top: 20px;
          //max-width: 1200px;
          min-height: 60vh;
          //background: #e6f8f3;
          border-radius: 10px;
          padding: 5px;
        }
      }
    }

    .class-jiaohu {
      background: #fff;
      margin-top: 20px;
      padding: 30px 10px 10px 10px;
      border-radius: 10px;

      .class-echarts-3 {
        margin-top: 20px;
        // max-width: 1200px;
        min-height: 80vh;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 10px;
      }
    }
  }

  .mt-20 {
    margin-top: 20px;
  }

  /deep/ .ant-tree li .ant-tree-node-content-wrapper {
    width: 130px; /* 设置树节点的宽度 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    overflow: hidden; /* 隐藏超出部分的文本 */
    text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
  }

  /deep/ .ant-empty {
    margin-top: 20px;
    max-width: 1200px;
    min-height: 30vh;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 10px;
    align-content: center;
  }

  .ant-empty2 {
    min-height: 80vh;
  }

  .ant-empty3 {
    min-height: 60vh;
    max-width: 100%;
  }
}

/deep/ .ant-checkbox-group {
  max-width: 90vw;
}

/deep/ .ant-checkbox-wrapper {
  //width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/deep/ .ant-radio-wrapper {
  font-size: 14px;
  //width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #000;
}

/deep/ .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}

/deep/ .ant-checkbox-wrapper {
  font-size: 14px;
  color: #000;
}
</style>

<script>
import { decryptDes } from 'utils/crypto.js'
import axios from 'axios'
import format from '../../utils/format.js'
import {
  getDrawOption,
  getGraphOption,
  getRadarOption
} from '../../utils/echartsOption'

export default {
  name: 'HomeStudentsDraw',
  data () {
    return {
      disabled: true,
      classShow: true,
      stuULShow: false,
      showRelDiv: false,
      bookList: [
        { name: '必修上册', key: 0 },
        { name: '必修下册', key: 1 },
        { name: '选择性必修上册', key: 2 },
        { name: '选择性必修中册', key: 3 },
        { name: '选择性必修下册', key: 4 }
      ],
      current: 0, // 课本年级
      classType: [
        { name: '班级行为表现', key: 1 },
        { name: '学生行为表现', key: 2 },
        { name: '学生交互表现', key: 3 }
      ],
      currentType: 0, // 班级分类
      classList: [{ name: '班级', id: 0 }],
      isPad: true,
      becurrent: 0,
      studentShow: false,
      classCheckedList: [], // 班级或学生选择
      beaviourCheckedList: [0, 1], // 班级表现选择
      studentModal: false, // 全部学生列表
      classModal: false, // 全部班级列表
      relClassId: '',
      downBtnLoading: false,
      classSelect: [],
      defautlClassName: [], // 班级默认选择

      plainOptions: [], // 选择的学生
      indeterminate: true, // 动画
      checkedList: [],
      studentsCheckedList: [],
      newStudentList: [],
      bookId: '', // 默认
      unitId: '1', // 默认
      type: 1,
      classIds: [],
      userId: '',
      access_token: '',

      styleId: '2', // 默认
      bookname: '必修上册', // 默认
      unitname: '第一单元', // 默认
      lessonname: '1 沁园春·长沙', // 默认
      replaceFields: {
        children: 'subList',
        title: 'displayName',
        key: 'id',
        unitId: 'unitId'
      },
      treeData: [],
      defaultExpandedKeys: ['01', '1', '2'], // 全部学生列表
      studentList: [], // 全部学生列表
      studentListCheck: [], // 选中的学生列表
      showLine: true,
      showIcon: false,
      classCurrent: 0,
      isDivVisible: false,
      readTotal: 0,
      radioTotal: 0,
      videoTotal: 0,
      dimensionTotal: 0,
      readingTotal: 0,
      objectiveTotal: 0,
      objectiveCorrectTotal: 0,
      activityTotal: 0,
      starTotal: 0,
      subjectiveTotal: 0,
      askTotal: 0,
      commentTotal: 0,
      praiseTotal: 0,
      main: true,
      create: true,
      positive: true,
      interaction: true,
      learntype: true,
      jiaohu: true,
      mainEmpty: true,
      createEmpty: true,
      positiveEmpty: true,
      interactionEmpty: true,
      learntypeEmpty: true,
      jiaohuEmpty: true,
      classJiaohu: '',
      classIdXingwei: [],
      className2s: [],
      userIds: [],
      userNames: [],
      tipsText: '加载中'
    }
  },
  mounted () {
    // 初始化接口参数，判断网页还是pad端访问
    this.loginInit()
    // 课文列表
    this.bookSimpleList()
    // 班级列表
    this.getClassList()
    // 学生列表
    this.getStudentList()
    // 获取图表数据
    this.getEchartsData()
  },
  methods: {
    loginInit () {
      // 初始化接口参数，判断网页还是pad端访问
      // const parameter = decryptDes('5ecfd021795f9a10245329b509849e106cc9d2d77acd05ad4a6c3c1761d3d48e3b226ed0bd4f3a0d8912aeef0ae53a44b7ea35859aff038bdd69909edc94c9029d1c189272ce8bf0')
      if (this.$route.path.indexOf('/accompanyStudy') === 0) {
        // 网页端
        this.isPad = false
        this.userId = this.$getUserInfo().id
        this.access_token = localStorage.getItem('access_token')
        // console.log('loginInit', '网页端')
      } else {
        // 移动端
        const parameter = decryptDes(this.$route.params.parameter)
        //  console.log(this.$route.params.parameter);
        const params = parameter.split('&')
        this.access_token = params[0]
        this.userId = params[1]
        localStorage.setItem('access_token', params[0])
        localStorage.setItem('userId', params[1])
        // console.log('loginInit', '移动端')
        //  console.log('route', this.$route.params.parameter)
        //  console.log('parameter', parameter)
        //  console.log('params', params)
        //  console.log('access_token', params[0])
        //  console.log('userId', params[1])
      }
    },
    bookSimpleList () {
      // 获取教材列表
      const _this = this
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/teacher/statistics2/bookStyleList',
          body: {
            token: _this.access_token,
            userId: _this.userId
          }
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            //  console.log('bookStyleList', res.resultData)
            _this.bookList = res.resultData
            _this.treeData = res.resultData
            _this.defaultExpandedKeys = ['01', '1', '2']
          }
        })
    },
    getClassList () {
      // 获取班级列表
      const _this = this
      _this
        .$fetch({
          url: _this.$baseUrl + 'ebook/teacher/statistics/listClass',
          body: {
            token: _this.access_token,
            userId: _this.userId
          }
        })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            _this.classList = res.resultData
            if (res.resultData[0].id) {
              _this.classCheckedList.push(res.resultData[0].id)
            }
            _this.classIds = _this.classCheckedList
            if (res.resultData[0].className) {
              _this.defautlClassName.push(res.resultData[0].className)
            }

            // _this.getChartData()
          }
        })
    },
    getStudentList () {
      // 获取学生列表
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics/listClassStu',
        body: {
          token: _this.access_token,
          userId: _this.userId
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          //  console.log('getStudentList', res.resultData)
          _this.studentList = res.resultData
          _this.newStudentList = res.resultData[0].users
          _this.defautlClassName.push(res.resultData[0].className)
        }
      })
    },

    toggleDiv () {
      // 显示隐藏按钮
      this.isDivVisible = !this.isDivVisible
      // 延迟1秒显示
      if (this.isPad) {
        setTimeout(() => {
          this.getEchartsData()
        }, 1000)
      } else {
        this.getEchartsData()
      }
    },
    enterDown () {
      // 交互关系导出
      this.downBtnLoading = true
    },
    async downloadExcel () {
      try {
        if (this.currentType == 2) {
          // 学生交互表现
          if (this.classJiaohu.length == 0) {
            this.$message.error('未选择班级')
            return
          }
        } else {
          // 班级行为表现 学生行为表现
          if (this.classIdXingwei.length == 0) {
            this.$message.error('未选择班级')
            return
          }
        }

        if (!this.unitId && !this.bookId) {
          this.$message.error('未选择课程')
          return
        }

        this.downBtnLoading = true

        let httpUrl = ''
        let params = {}
        if (this.currentType === 2) {
          // 学生交互表现
          httpUrl = this.$httpConfig.exportUserRelationship
          params = {
            // POST 请求的参数
            access_token: this.access_token,
            classId: this.classJiaohu,
            styleId: this.unitId,
            bookId: this.bookId,
            userId: this.userId
          }
        } else {
          let exportType = ''
          if (this.currentType === 0) {
            // 班级行为表现
            if (this.isUnitOrBook()) {
              if (this.styleId === '') {
                //  班级book
                exportType = 'classesBook'
              } else {
                // 单元
                exportType = 'classesUnit'
              }
            } else {
              // 课程
              exportType = 'classesStyles'
            }
          } else {
            // 用户行为表现
            if (this.isUnitOrBook()) {
              if (this.styleId === '') {
                //  班级book
                exportType = 'usersBook'
              } else {
                // 单元
                exportType = 'usersUnit'
              }
            } else {
              // 课程
              exportType = 'usersStyles'
            }
          }
          httpUrl = this.$httpConfig.exportExcel
          const styleIds = []
          styleIds.push(this.styleId)
          params = {
            // POST 请求的参数
            access_token: this.access_token,
            classIds: this.classIdXingwei,
            userIds: this.userIds,
            styleId: this.unitId,
            bookId: this.bookId,
            styleIds: styleIds,
            exportType: exportType
          }
        }

        const response = await axios.post(httpUrl, params, {
          responseType: 'blob' // 设置响应类型为二进制流
        })
        // 创建一个 Blob 对象，并设置 MIME 类型
        const blob = new Blob([response.data], { type: 'application/octet-stream' })
        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        // 创建一个 <a> 元素，设置属性并模拟点击下载
        const link = document.createElement('a')
        link.href = url
        if (this.currentType === 2) {
          link.setAttribute('download', '【学生交互关系】ICAP统计结果' + format.formatDayTime(new Date().valueOf()) + '.zip') // 设置下载文件名
        } else if (this.currentType === 1) {
          link.setAttribute('download', '【学生行为表现】ICAP统计结果' + format.formatDayTime(new Date().valueOf()) + '.zip') // 设置下载文件名
        } else {
          link.setAttribute('download', '【班级行为表现】ICAP统计结果' + format.formatDayTime(new Date().valueOf()) + '.zip') // 设置下载文件名
        }

        document.body.appendChild(link)
        link.click()

        // 清理资源
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.downBtnLoading = false
      } catch (error) {
        console.error('Error downloading Excel file:', error)
        // 处理错误
        this.$message.error('发生错误')
        this.downBtnLoading = false
      }
    },
    onSelect (selectedKeys, info) {
      console.log('selectedKeys', selectedKeys)
      console.log('info', info)

      // 获取课程id
      this.styleId = selectedKeys[0] || ''
      // 获取单元id
      this.unitId = info.selectedNodes[0].data.props.unitId || ''
      // 获取书籍id
      this.bookId = info.selectedNodes[0].data.props.bookId || ''
      // 课本的id
      if (!this.unitId && !this.bookId) {
        this.unitId = ''
        this.tipsText = '未选择课程'
      }
      if (this.styleId.startsWith('0')) {
        this.styleId = ''
      }
      // 显示选择的课文
      const outerIds = this.findOuterIds(this.treeData, this.styleId)
      //  console.log('outerIds', outerIds)
      this.bookname = outerIds[0] || info.selectedNodes[0].data.props.displayName || ''
      this.unitname = outerIds[1] || ''
      this.lessonname = outerIds[2] || ''

      // console.log('unitId-onSelect', info.selectedNodes[0].data.props.unitId)
      // console.log('bookId-onSelect', info.selectedNodes[0].data.props.bookId)
      // console.log('styleId-onSelect', info.selectedNodes[0].key)
      // console.log('bookId', this.bookId)
      // console.log('unitId', this.unitId)
      // console.log('styleId', this.styleId)

      // 获取图表数据
      this.getEchartsData()
    },
    findOuterIds (data, targetId) {
      let path = []

      function search (array, currentPath) {
        for (const item of array) {
          const newPath = [...currentPath, item.displayName]

          if (item.id === targetId) {
            path = newPath
            return true
          }

          if (item.subList && search(item.subList, newPath)) {
            return true
          }
        }
        return false
      }

      search(data, [])
      return path
    },
    onTypeChange (e) {
      // 表现选择变化
      //  console.log('onTypeChange', e)
      this.currentType = e
      if (this.currentType == 2) {
        // 学生交互表现
        this.classJiaohu = ''
      } else {
        // 班级行为表现 学生行为变现
        this.classIdXingwei = []
        this.classCheckedList = []
        this.studentsCheckedList = []
        this.getStudentData()
      }
      this.getEchartsData()
    },
    classChange (e) {
      // 选择的班级
      //  console.log(e)
      this.classIdXingwei = e.map(item => item.id)
      this.className2s = e.map(item => item.className)
      // this.getChartData()
      if (this.currentType === 1) {
        // 选择学生
        this.getStudentData()
      } else {
        this.userIds = []
        this.userNames = []
      }

      this.getEchartsData()
    },
    relationshipChange (e) {
      // 选择的班级
      //  console.log('relationshipChange', e.target.value)
      this.classJiaohu = e.target.value.id
      this.userRelationship()
    },
    getStudentData () {
      // 筛选选中班级的学生
      const filteredStudents = this.studentList.filter(student => this.classIdXingwei.includes(student.id) && student.users !== null)
      this.studentListCheck = filteredStudents.flatMap(student => student.users)
      //  console.log('studentListCheck', this.studentListCheck)
      //  console.log('studentList', this.studentList)
      //  console.log('classIds', this.classIds)
      //  console.log('classIdXingwei', this.classIdXingwei)
      // 从 userIds 中移除不存在于 studentListCheck 中的 userId
      this.userIds = this.userIds.filter(userId => this.studentListCheck.find(student => student.userId === userId))
      this.userNames = this.userNames.filter(userName => this.studentListCheck.find(student => student.userName === userName))
    },
    studentChange (e) {
      // 选择的学生
      if (e.length <= 3) {
        //  console.log('studentChange', e)
        this.studentListCheck.forEach(userA => {
          // 使用some方法检查数组B是否存在具有相同userId的对象
          userA.disabled = false
        })
        this.userIds = e.map(item => item.userId)
        this.userNames = e.map(item => item.userName)
        // this.userNames = e.map(item => item.userName.length > 6 ? item.userName.slice(0, 6) + '...' : item.userName)
        this.getEchartsData()
      } else {
        this.studentsCheckedList.pop()
        this.studentListCheck.forEach(userA => {
          // 使用some方法检查数组B是否存在具有相同userId的对象
          userA.disabled = !this.studentsCheckedList.some(userB => userB.userId === userA.userId)
        })
        this.$message.error('最多选择三个')
      }
    },
    studentShowMore () {
      // 学生显示全部
      const filteredStudents = this.studentList.filter(student => this.classIdXingwei.includes(student.id) && student.users !== null)
      this.studentListCheck = filteredStudents.flatMap(student => student.users)
    },
    getEchartsData () {
      if (this.currentType === 0) {
        this.main = true
        this.create = true
        this.positive = true
        this.interaction = true
        this.learntype = true
        // 班级行为表现
        this.tipsText = this.classIdXingwei.length > 0 ? '加载中' : '未选择班级'
        //  console.log('unitId-getEchartsData', this.unitId)
        if (!this.unitId && !this.bookId) {
          this.tipsText = '未选择课程'
          return
        }
        this.classStatistics4Active()
        this.classStatistics4Passivity()
        this.classStatistics4Interaction()
        this.classStatistics4Create()
        // 学习类型
        this.studyTypeStatistics(1)
      } else if (this.currentType === 1) {
        // 学生行为表现
        this.tipsText = this.userIds.length > 0 ? '加载中' : '未选择学生'
        if (!this.unitId && !this.bookId) {
          this.tipsText = '未选择课程'
          return
        }
        this.main = true
        this.create = true
        this.positive = true
        this.interaction = true
        this.learntype = true
        this.getStudentData()
        this.userStatistics4Active()
        this.userStatistics4Passivity()
        this.userStatistics4Interaction()
        this.userStatistics4Create()
        // 学习类型
        this.studyTypeStatistics(2)
      } else {
        // 学生交互表现
        this.tipsText = this.classJiaohu === '' ? '未选择班级' : '加载中'
        this.jiaohu = true
        this.userRelationship()
      }
    },
    classStatistics4Passivity () {
      // 班级表现被动行为
      //  console.log('styled', this.styleId)
      //  console.log('unitid', this.unitId)
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元 或者 书
        url = 'ebook/teacher/statistics2/classStatistics4Passivity'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/classStyleStatistics4Passivity'
        styleIds.push(this.styleId)
      }

      _this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          classIds: _this.classIdXingwei
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.main = false
          this.mainEmpty = !data

          // 将毫秒转化为00:00:00的格式
          this.readTotal = format.formattedTime(data.readTotal)
          this.radioTotal = format.formattedTime(data.radioTotal)
          this.videoTotal = format.formattedTime(data.videoTotal)

          const readArray = data.readArray.map(seconds => (seconds / 3600).toFixed(1))
          const radioArray = data.radioArray.map(seconds => (seconds / 3600).toFixed(1))
          const videoArray = data.videoArray.map(seconds => (seconds / 3600).toFixed(1))
          const dataSeries = [
            { key: '阅读行为', value: readArray },
            { key: '听诵读', value: radioArray },
            { key: '视频学习', value: videoArray }
          ]
          const option = getDrawOption(dataSeries, this.className2s, true)
          this.showChart('main', option)
        }
      })
    },
    classStatistics4Active () {
      // 班级表现主动行为
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元
        url = 'ebook/teacher/statistics2/classStatistics4Active'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/classStyleStatistics4Active'
        styleIds.push(this.styleId)
      }

      _this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          classIds: _this.classIdXingwei
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.positive = false
          this.positiveEmpty = !data

          this.dimensionTotal = data.dimensionTotal
          this.readingTotal = data.readingTotal
          this.objectiveTotal = data.objectiveTotal
          this.objectiveCorrectTotal = data.objectiveCorrectTotal

          const dataSeries = [
            { key: '标注', value: data.dimensionArray },
            { key: '朗读', value: data.readingArray },
            { key: '完成客观题数量', value: data.objectiveArray },
            { key: '正确客观题数量', value: data.objectiveCorrectArray }
          ]
          const option = getDrawOption(dataSeries, this.className2s)
          this.showChart('positive', option)
        }
      })
    },
    classStatistics4Create () {
      // 班级表现-构建行为
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元
        url = 'ebook/teacher/statistics2/classStatistics4Create'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/classStyleStatistics4Create'
        styleIds.push(this.styleId)
      }

      _this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          classIds: _this.classIdXingwei
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.create = false
          this.createEmpty = !data

          this.activityTotal = data.activityTotal
          this.starTotal = data.starTotal
          this.subjectiveTotal = data.subjectiveTotal
          const dataSeries = [
            { key: '任务下活动数量', value: data.activityArray },
            { key: '任务下活动所获得星星数量', value: data.starArray },
            { key: '主观题数量', value: data.subjectiveArray }
          ]
          const option = getDrawOption(dataSeries, this.className2s)
          this.showChart('create', option)
        }
      })
    },
    classStatistics4Interaction () {
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元
        url = 'ebook/teacher/statistics2/classStatistics4Interaction'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/classStyleStatistics4Interaction'
        styleIds.push(this.styleId)
      }
      // 班级表现被动行为（单元）
      _this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          classIds: _this.classIdXingwei
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.interaction = false
          this.interactionEmpty = !data

          this.askTotal = data.askTotal
          this.commentTotal = data.commentTotal
          this.praiseTotal = data.praiseTotal
          const dataSeries = [
            { key: '评论', value: data.commentArray },
            { key: '提问', value: data.askArray },
            { key: '点赞', value: data.praiseArray }
          ]
          const option = getDrawOption(dataSeries, this.className2s)
          this.showChart('interaction', option)
        }
      })
    },

    userStatistics4Passivity () {
      // 学生表现--被动行为
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元
        url = 'ebook/teacher/statistics2/userStatistics4Passivity'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/userStyleStatistics4Passivity'
        styleIds.push(this.styleId)
      }
      _this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          userIds: _this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.main = false
          this.mainEmpty = !data

          this.readTotal = format.formattedTime(data.readTotal)
          this.radioTotal = format.formattedTime(data.radioTotal)
          this.videoTotal = format.formattedTime(data.videoTotal)

          const readArray = data.readArray.map(seconds => (seconds / 3600).toFixed(1))
          const radioArray = data.radioArray.map(seconds => (seconds / 3600).toFixed(1))
          const videoArray = data.videoArray.map(seconds => (seconds / 3600).toFixed(1))
          const dataSeries = [
            { key: '阅读行为', value: readArray },
            { key: '听诵读', value: radioArray },
            { key: '视频学习', value: videoArray }
          ]
          const option = getDrawOption(dataSeries, this.userNames, true)
          this.showChart('main', option)
        }
      })
    },
    userStatistics4Active () {
      // 学生表现--主动行为
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元
        url = 'ebook/teacher/statistics2/userStatistics4Active'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/userStyleStatistics4Active'
        styleIds.push(this.styleId)
      }
      this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          userIds: _this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.positive = false
          this.positiveEmpty = !data

          this.dimensionTotal = data.dimensionTotal
          this.readingTotal = data.readingTotal
          this.objectiveTotal = data.objectiveTotal
          this.objectiveCorrectTotal = data.objectiveCorrectTotal

          const dataSeries = [
            { key: '标注', value: data.dimensionArray },
            { key: '朗读', value: data.readingArray },
            { key: '完成客观题数量', value: data.objectiveArray },
            { key: '正确客观题数量', value: data.objectiveCorrectArray }
          ]
          const option = getDrawOption(dataSeries, this.userNames)
          this.showChart('positive', option)
        }
      })
    },
    userStatistics4Create () {
      // 班级表现被动行为（单元）
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元
        url = 'ebook/teacher/statistics2/userStatistics4Create'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/userStyleStatistics4Create'
        styleIds.push(this.styleId)
      }

      _this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          userIds: this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.create = false
          this.createEmpty = !data

          this.activityTotal = data.activityTotal
          this.starTotal = data.starTotal
          this.subjectiveTotal = data.subjectiveTotal

          const dataSeries = [
            { key: '任务下活动数量', value: data.activityArray },
            { key: '任务下活动所获得星星数量', value: data.starArray },
            { key: '主观题数量', value: data.subjectiveArray }
          ]
          const option = getDrawOption(dataSeries, this.userNames)
          this.showChart('create', option)
        }
      })
    },
    userStatistics4Interaction () {
      // 班级表现被动行为（单元）
      const _this = this
      let url = ''
      const styleIds = []
      if (_this.isUnitOrBook()) {
        // 单元或者书
        url = 'ebook/teacher/statistics2/userStatistics4Interaction'
      } else {
        // 课程
        url = 'ebook/teacher/statistics2/userStyleStatistics4Interaction'
        styleIds.push(this.styleId)
      }
      _this.$fetch({
        url: _this.$baseUrl + url,
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.unitId,
          styleIds: styleIds,
          userIds: _this.userIds
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData
          this.interaction = false
          this.interactionEmpty = !data

          this.askTotal = data.askTotal
          this.commentTotal = data.commentTotal
          this.praiseTotal = data.praiseTotal

          const dataSeries = [
            { key: '评论', value: data.commentArray },
            { key: '提问', value: data.askArray },
            { key: '点赞', value: data.praiseArray }
          ]
          const option = getDrawOption(dataSeries, this.userNames)
          _this.showChart('interaction', option)
        }
      })
    },

    userRelationship () {
      const _this = this
      this.tipsText = this.classJiaohu === '' ? '未选择班级' : '加载中'
      // 班级表现被动行为（单元）

      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/userRelationship',
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.styleId,
          classId: _this.classJiaohu,
          // type：1 班级（默认）， 2 学生
          type: 1
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const data = res.resultData || []
          this.jiaohu = false
          this.jiaohuEmpty = !(res.resultData !== null && res.resultData !== '')

          // 指定图表的配置项和数据
          const option = getGraphOption(data)
          this.showChart('jiaohu', option)
        }
      })
    },
    studyTypeStatistics (type) {
      // 学习类型
      const _this = this
      this.$fetch({
        url: _this.$baseUrl + 'ebook/teacher/statistics2/studyTypeStatistics',
        body: {
          bookId: _this.bookId,
          token: _this.access_token,
          styleId: _this.styleId,
          classIds: _this.classIdXingwei,
          userIds: _this.userIds,
          // type：1 班级（默认）， 2 学生
          type: type
        }
      }).done((res) => {
        if (res && res.success && res.resultCode === 0) {
          const dataSeries = res.resultData
          this.learntype = false
          this.learntypeEmpty = !dataSeries

          // 获取雷达图配置项
          const radarOption = getRadarOption(dataSeries)
          this.showChart('learntype', radarOption)
        }
      })
    },
    isUnitOrBook () {
      // 如果是单元/书，返回true；如果是课程，返回false
      return this.styleId === this.unitId || this.styleId === ''
    },

    showChart (containerId, option) {
      const _this = this
      setTimeout(() => {
        try {
          const chartStar = _this.$echarts.init(document.getElementById(containerId))
          chartStar.setOption(option)
          chartStar.resize()
        } catch (error) {
        }
      }, 200)
    }
  }
}
</script>
